import { render, staticRenderFns } from "./AddressSidebar.vue?vue&type=template&id=76efda60&"
import script from "./AddressSidebar.vue?vue&type=script&lang=js&"
export * from "./AddressSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports